module.exports = __webpack_public_path__ + "img/Animales-KC7.239797d3.png";